import { render } from "./recycleGoods.vue?vue&type=template&id=c57365e4&scoped=true"
import script from "./recycleGoods.vue?vue&type=script&lang=js"
export * from "./recycleGoods.vue?vue&type=script&lang=js"

import "./recycleGoods.vue?vue&type=style&index=0&id=c57365e4&scoped=true&lang=css"

import exportComponent from "D:\\未知比特项目\\前端项目\\adminSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57365e4"]])

export default __exports__